import React__default from "react";
import { ImageIcon } from "@radix-ui/react-icons";
import styles from "../../styles/ui.module.css.js";
const ImagePlaceholder = () => {
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.imagePlaceholder }, /* @__PURE__ */ React__default.createElement(ImageIcon, null));
};
export {
  ImagePlaceholder
};
